import { Component, h, Prop, Watch } from '@stencil/core';

@Component({
    tag: 'rentware-search-filters-accordion',
    shadow: false,
})
export class RentwareSearchFiltersAccordion {
    @Prop() label: string;
    @Prop() additionalInfo: string;
    @Prop() opened: boolean;
    @Prop() onAccordionClick: () => void;

    slotContainer: HTMLDivElement;

    componentDidLoad() {
        this.handleOpenedChanged();
    }

    @Watch('opened')
    handleOpenedChanged() {
        if (!this.opened) {
            this.slotContainer.style.maxHeight = "0px";
        } else {
            this.slotContainer.style.maxHeight = this.slotContainer.scrollHeight + "px";
        }
    }

    get arrowSVG() {
        if (this.opened) {
            return (
                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 7L7 1L13 7" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            )
        } else {
            return (
                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L7 7L13 1" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            )
        }
    }

    render() {
        return (
            <div class="FiltersAccordionContainer">
                <div
                    class="AccordionHeader"
                    onClick={this.onAccordionClick}
                    tabIndex={0}
                >
                    {this.label}

                    <div class="AccordionHeaderRight">
                        {this.additionalInfo}

                        {this.arrowSVG}
                    </div>
                </div>

                <rentware-spacer size="S" />

                <div
                    class="AccordionSlot"
                    ref={(el) => this.slotContainer = el}
                >
                    <slot />
                </div>
            </div>
        )
    }
}
